import { FunctionComponent, useState } from 'react';

import { $ContainerStyled } from './Tabs.styles';
import { Tab } from './Tabs.types';
import TabsBody from './TabsBody';
import TabsNav from './TabsNav';

interface TabsProps {
  tabs: Tab[];
  values?: Record<string, unknown>;
  errors?: string[];
  initialActiveTab: Tab;
  dataTestId?: string;
  withTransition?: boolean;
  onChange?: (value: Tab) => void;
  hasBottomBorder?: boolean;
}

const Tabs: FunctionComponent<TabsProps> = ({
  tabs,
  values,
  errors = [],
  initialActiveTab,
  dataTestId,
  withTransition = true,
  onChange,
  hasBottomBorder,
}) => {
  const [activeTab, setActiveTab] = useState<Tab>(initialActiveTab);

  return (
    <$ContainerStyled>
      <TabsNav
        activeTab={activeTab}
        tabs={tabs}
        errors={errors}
        onTabChange={(value) => {
          setActiveTab(value);
          if (onChange) {
            onChange(value);
          }
        }}
        dataTestId={dataTestId}
        hasBottomBorder={hasBottomBorder}
      />
      <TabsBody
        activeTab={activeTab}
        tabs={tabs}
        values={values}
        withTransition={withTransition}
      />
    </$ContainerStyled>
  );
};

export default Tabs;
